<script>
export default {
    name: 'PositionHelpers',

    data() {
        return {
            imageOffset: 10
        }
    },
    methods: {
        textRange(node, from, to) {
            const range = document.createRange()
            range.setEnd(node, to == null ? node.nodeValue.length : to)
            range.setStart(node, from || 0)
            return range
        },

        singleRect(object, bias) {
            const rects = object.getClientRects()
            return !rects.length ? object.getBoundingClientRect() : rects[bias < 0 ? 0 : rects.length - 1]
        },

        coordsAtPos(view, pos, end = false) {
            const {
                node,
                offset
            } = view.docView.domFromPos(pos);
            let side;
            let rect;
            if (node.nodeType === 3) {
                if (end && offset < node.nodeValue.length) {
                    rect = this.singleRect(this.textRange(node, offset - 1, offset), -1);
                    side = 'right';
                } else if (offset < node.nodeValue.length) {
                    rect = this.singleRect(this.textRange(node, offset, offset + 1), -1);
                    side = 'left';
                }
            } else if (node.firstChild) {
                if (offset < node.childNodes.length) {
                    const child = node.childNodes[offset]
                    rect = this.singleRect(child.nodeType === 3 ? this.textRange(child) : child, -1);
                    side = 'left';
                }
                if ((!rect || rect.top === rect.bottom) && offset) {
                    const child = node.childNodes[offset - 1];
                    rect = this.singleRect(child.nodeType === 3 ? this.textRange(child) : child, 1);
                    side = 'right';
                }
            } else {
                rect = node.getBoundingClientRect()
                side = 'left'
            }

            var element = this.$el;
            var parent;

            if (element) {
                parent = element.offsetParent;
            }

            var result = {
                y: rect.top,
                x: rect["left"]
            }
            if (parent) {
                var box = parent.getBoundingClientRect();
                result.y = rect.top - box.top;
                result.x = Math.round(result.x - box.left)
            }

            return result;
        },

        CalculateLeftBasic() {
            return this.coordsAtPos(this.editor.view, this.editor.state.selection.from).x;
        },

        CalculateLeftReference() {
            return this.coordsAtPos(this.editor.view, this.editor.state.selection.$head.start(2)).x - 16;
        },

        CalculateTopPlus() {
            var top = this.coordsAtPos(this.editor.view, this.editor.state.selection.from).y;
            return top;
        },

        CalculateTopBasic() {
            var top = this.coordsAtPos(this.editor.view, this.editor.state.selection.from).y;
            top = this.menuOffset(top);
            return top;
        },

        CalculateTopImage() {
            return this.coordsAtPos(this.editor.view, this.editor.state.selection.from).y + this.imageOffset;
        },

        CalculateLeftImage() {
            return this.coordsAtPos(this.editor.view, this.editor.state.selection.from).x + this.imageOffset;
        },

        CalculateTopReference() {

            var top = this.coordsAtPos(this.editor.view, this.editor.state.selection.$head.start(2)).y;
            top = this.menuOffset(top);
            return top;
        },

        CalculateTopIframe() {
            var top = this.coordsAtPos(this.editor.view, this.editor.state.selection.$from.before(1)).y;
            top = this.menuOffset(top);
            return top;
        },

        CalculateTopTable() {
            var top = this.coordsAtPos(this.editor.view, this.editor.state.selection.$head.start(1)).y
            top = this.menuOffset(top);
            return top;
        },

        menuOffset(elementTop) {
            var menuHeight = 50; //our menus have a height of 55px
            return elementTop - menuHeight;
        },

        getFontSize() {
            return parseFloat(getComputedStyle(this.$el).fontSize)

        },
    }
}
</script>
